import { z } from 'zod';
import { EventListItemDto } from './event';
import { NewsDto } from './news';

export const FeedItem = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('news'), news: NewsDto }),
  z.object({ kind: z.literal('event'), event: EventListItemDto }),
]);
export type FeedItem = z.infer<typeof FeedItem>;

export const FeedPage = z.object({
  items: z.array(FeedItem),
  nextCursor: z.string().nullable(),
});
export type FeedPage = z.infer<typeof FeedPage>;
